// library
import classNames from "classnames";
import { useState } from "react";

import Onboarding from "../../../components/onboarding";
import { EVENT_LOCAL_STORAGE_LOGIN } from "../../../setup/context/events";
import AuthEntryPoint from "../authEntryPoint";
// styles
import styles from "./login.module.scss";

const Login = () => {
  const [toggleOnboarding, setToggleOnboarding] = useState(true);
  const authAction = () => {
    window.dispatchEvent(new Event(EVENT_LOCAL_STORAGE_LOGIN));
  };

  return (
    <div className={styles.container}>
      <div
        className={classNames(
          styles.section,
          styles.bg,
          styles.left,
          !toggleOnboarding && styles.showSection
        )}>
        <AuthEntryPoint
          toggleOnboarding={toggleOnboarding}
          setToggleOnboarding={setToggleOnboarding}
          authAction={authAction}
        />
      </div>
      <div
        className={classNames(
          styles.section,
          styles.center,
          styles.right,
          toggleOnboarding && styles.showSection
        )}>
        <Onboarding
          handleClose={() => setToggleOnboarding(!toggleOnboarding)}
        />
      </div>
    </div>
  );
};

export default Login;
